import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/lib/util/colors';

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'mdi',
    },
    theme: {
        options: {
            customProperties: true,
        },
        themes: {
            dark: {
                'accent': colors.blue.lighten3,
                'secondary': colors.blue.lighten3,
                'primary': '#ff8f15',
                'greydarken4': colors.grey.darken4,
                'alternative-grey': '#282828',
                'icon-bg': '#393939',
            },
            light: {
                'accent': colors.blue.lighten3,
                'secondary': colors.blue.lighten3,
                'primary': '#ff8f15',
                'greylighten4': colors.grey.lighten4,
                'alternative-grey': '#ebebeb',
                'icon-bg': '#d2d1d1',
            },
        },
    },
});
